import { useState } from "react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";

const TOPICS = ["Course enquiry", "Community partnership", "Volunteering", "Donations", "General"];
const empty = { name: "", email: "", phone: "", topic: "Course enquiry", message: "" };

export default function Contact() {
  const [form, setForm] = useState(empty);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/enquiries", form);
      toast.success("Thanks — your message has been sent. We'll reply soon.");
      setForm(empty);
    } catch (err) { toast.error(formatError(err)); } finally { setBusy(false); }
  };

  return (
    <main>
      <PageHero eyebrow="Contact" lines={["Yarn", <span key="w" className="italic text-ochre">with us.</span>]}
        intro="Questions about a course, partnering with us or volunteering? Send a message and our team will get back to you." image="/img/rock_formations.jpg" />
      <section className="bg-sand px-5 py-20 sm:px-10">
        <div className="mx-auto grid max-w-[1440px] gap-14 lg:grid-cols-12">
          <Reveal className="space-y-8 lg:col-span-4">
            {[["Email", "GACenquiries@outlook.com", "mailto:GACenquiries@outlook.com"], ["Phone", "0416923905", "tel:0416923905"], ["Location", "[Suburb] NSW [Postcode]"], ["Hours", "[Opening hours]"]].map(([k, v, href]) => (
              <div key={k} className="border-t border-ink/15 pt-5"><p className="eyebrow text-ochre">{k}</p>
                {href ? <a href={href} data-testid={`contact-${k.toLowerCase()}-link`} className="mt-2 block break-all font-display text-2xl transition-colors hover:text-ochre">{v}</a> : <p className="mt-2 font-display text-2xl">{v}</p>}
              </div>
            ))}
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-7 lg:col-start-6">
            <form onSubmit={submit} data-testid="contact-form" className="space-y-6">
              <div className="flex flex-wrap gap-2">
                {TOPICS.map((t) => (
                  <button type="button" key={t} data-testid={`topic-${t.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => setForm({ ...form, topic: t })}
                    className={`rounded-full border px-4 py-2 text-sm transition-colors ${form.topic === t ? "border-ochre bg-ochre text-sand" : "border-ink/25 hover:border-ink"}`}>{t}</button>
                ))}
              </div>
              <div className="grid gap-6 sm:grid-cols-2">
                <input data-testid="contact-name-input" required placeholder="Your name" value={form.name} onChange={set("name")} className="field" />
                <input data-testid="contact-email-input" required type="email" placeholder="Email" value={form.email} onChange={set("email")} className="field" />
              </div>
              <input data-testid="contact-phone-input" placeholder="Phone (optional)" value={form.phone} onChange={set("phone")} className="field" />
              <textarea data-testid="contact-message-input" required rows={5} placeholder="How can we help?" value={form.message} onChange={set("message")} className="field resize-none" />
              <button data-testid="contact-submit-button" disabled={busy} className="btn-ochre disabled:opacity-60">{busy ? "Sending…" : "Send message"}</button>
            </form>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
